import { createFileRoute } from "@tanstack/react-router";
import { HelpLink, HelpNote, HelpPage, HelpSection } from "@/components/HelpPage";

export const Route = createFileRoute("/livraison")({
  head: () => ({
    meta: [
      { title: "Livraison — Sunset Concept Store" },
      {
        name: "description",
        content:
          "Livraison gratuite partout au Maroc sous 3 à 5 jours ouvrables, paiement à la livraison. Toutes les informations sur la livraison Sunset Concept Store.",
      },
      { property: "og:title", content: "Livraison — Sunset Concept Store" },
      {
        property: "og:description",
        content: "Livraison gratuite partout au Maroc, sous 3 à 5 jours ouvrables, avec paiement à la livraison.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://sunsetconcept.store/livraison" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sunsetconcept.store/livraison" }],
  }),
  component: LivraisonPage,
});

function LivraisonPage() {
  return (
    <HelpPage
      title="Livraison"
      intro="Chez SUNSET Concept Store, nous préparons chaque commande avec soin afin qu'elle vous parvienne dans les meilleures conditions."
    >
      <HelpSection title="Livraison partout au Maroc">
        <p>Nous livrons vos commandes dans toutes les villes du Maroc.</p>
      </HelpSection>

      <HelpSection title="Frais de livraison">
        <p>La livraison est gratuite.</p>
      </HelpSection>

      <HelpSection title="Délais de livraison">
        <p>Votre commande est généralement livrée sous 3 à 5 jours ouvrables après confirmation.</p>
      </HelpSection>

      <HelpSection title="Confirmation de commande">
        <p>
          Après avoir passé votre commande, notre équipe peut vous contacter par téléphone afin de confirmer vos
          informations et votre adresse de livraison.
        </p>
      </HelpSection>

      <HelpSection title="Paiement">
        <p>Le paiement s'effectue à la livraison.</p>
      </HelpSection>

      <HelpSection title="Suivi de votre commande">
        <p>
          Pour toute question concernant votre livraison, vous pouvez nous contacter via notre page{" "}
          <HelpLink to="/contact">Contact</HelpLink>.
        </p>
      </HelpSection>

      <HelpNote>
        Une question sur un échange ou un retour ? Consultez notre page{" "}
        <HelpLink to="/echanges-retours">Échanges &amp; retours</HelpLink> ou écrivez-nous directement via la page{" "}
        <HelpLink to="/contact">Contact</HelpLink>.
      </HelpNote>
    </HelpPage>
  );
}
